export const CLASS_NAMES = {
  baseSelect:
    "appearance-none bg-select-chevron focus:bg-select-chevron-active bg-no-repeat bg-right-4 invalid:text-neutral-400 overflow-hidden !pr-12",
};

export const DEFAULT_VALUE = "";
